export const LOGIN_POST = 'POST/tokens';
export const REFRESH_TOKEN_POST = 'POST/tokens/renew';
export const LOGIN_SSO_GET = 'GET/tokens/oauth';
